export interface Deferred<T> {
  status: 'pending' | 'resolved' | 'rejected'
  promise: Promise<T>
  resolve: (value: T | PromiseLike<T>) => void
  reject: (reason: unknown) => void
}

export function createDeferred<T = void>(): Deferred<T> {
  let resolveCallback: Deferred<T>['resolve']
  let rejectCallback: Deferred<T>['reject']

  const deferred: Deferred<T> = {
    status: 'pending',
    promise: new Promise<T>((resolve, reject) => {
      resolveCallback = resolve
      rejectCallback = reject
    }),
    resolve: value => {
      resolveCallback(value)
      deferred.status = 'resolved'
    },
    reject: reason => {
      rejectCallback(reason)
      deferred.status = 'rejected'
    },
  }

  return deferred
}
